<template>
  <div class="fts-solution-information" :class="{'solution-information--child': child}">
    <fts-label-group
      :item="item"
      information
    />
    <template v-if="item.type === 14 && item.fields && item.fields.length">
      <fts-solution-information
        v-for="y in item.fields"
        :key="y.id"
        :item="y"
        child
      />
    </template>
    <template v-if="item.type === 27 && item.optionList && item.optionList.length">
      <div
        v-for="y in item.optionList"
        :key="y.id"
        class="solution-information-option-wrapper"
      >
        <span
          class="solution-information-option"
          :style="{'background-color': getOptionBackgroundColor(y.name)}"
        >
          {{ y.name }}
        </span>
      </div>
    </template>
  </div>
</template>

<script>
import commons from '../../commons/commons';

import FTSLabelGroup from '../FTSLabelGroup.vue';

export default {
  name: "fts-solution-information",
  components: {
    "fts-label-group": FTSLabelGroup
  },
  props: {
    item: Object,
    child: Boolean
  },
  methods: {
    getOptionBackgroundColor(text) {
      return commons.selectOptionBackground({
        optionList: this.item.optionList,
        text: text
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/vars.scss";

.fts-solution-information {
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: var(--fts-text);
  .solution-information-option-wrapper {
    margin-top: 0.375rem;
    margin-left: 1.25rem;
    .solution-information-option {
      max-width: 100%;
      display: inline-block;
      padding-left: 0.375rem;
      padding-right: 0.375rem;
      border-radius: $comfort-border-radius;
      vertical-align: top;
      @include text-overflow-ellipsis;
    }
    & + .solution-information-option-wrapper {
      margin-top: 0.625rem;
    }
  }
  &.solution-information--child {
    margin-left: 1.25rem;
    margin-top: 0.375rem;
  }
  & + .fts-solution-information {
    margin-top: 0.625rem;
  }
}
</style>